// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n * Dashboard css File\n*/", "",{"version":3,"sources":["webpack://src/Components/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;;CAAA","sourcesContent":["/*\n * Dashboard css File\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
